import React from "react";

import { withStyles } from '@material-ui/styles';
import { Link } from 'react-router-dom';
import withCurrentUser from '../../../hocs/with_current_user.js';
import withShowToast from '../../../hocs/with_show_toast.js';
import withKeepNavigationState from "../../../hocs/with_keep_navigation_state.js";
import { compose } from 'redux';

import I18n from "../../../base/i18n.js.jsx";

import FormFields from "../../../base/form/form_fields.js";
import Button from "../../../base/buttons/button.js";
import BackButton from "../../../base/buttons/back_button.js";

import BaseSessionPage from "./components/base_session_page.js.jsx";
import SignInNav from "./components/sign_in_nav.js";

import { SignInInfoModel } from "../../../models/session/sign_in_info_model.js";

import LoginUseCase from "../../../use_cases/sessions/login_use_case.js";
import URLParams from "../../../utils/url_params.js";

import Routes from "../../routes.js";

const styles = theme => ({
  button: {
    margin: "32px 0px",
    width: "100%",
    ['@media (max-width: 768px)']: {
      marginBottom: "45px"
    }
  },
  comeBack: {
    marginBottom: "160px"
  },
  backContainer: {
    display: "flex",
    marginTop: "8px"
  },
  text: {
    display: "block",
    fontSize: "24px",
    fontWeight: theme.typography.fontWeightLight,
    marginBottom: "70px"
  },
  signInContainer: {
    marginTop: "24px",
    display: "flex",
    justifyContent: "flex-end",
    ['@media (max-width: 768px)']: {
      marginTop: "15px"
    }
  },
  forgotPasswordLink: {
    color: theme.palette.grayText,
    fontSize: "14px",
    lineHeight: "1.25",
    textDecoration: "none",
    "&:hover" : {
      textDecoration: "underline",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "12px"
    }
  }
});

class SignInPage extends React.Component {

  constructor(props) {
    super(props);

    this.signInInfo = {
      email: URLParams.get("email"),
      projectId: props.projectId
    }

    this.state = {

    };

    this.formFields = SignInInfoModel.formFields().map((field) => {
      if(field.name === "password") {
        field.disableShowPassword = true;
      }
      return field;
    })

    this.onItemChange = this.onItemChange.bind(this);

    this.onSubmit = this.onSubmit.bind(this);

    this.onComeBack = this.onComeBack.bind(this);
  }
  
  onItemChange(changedItem) {
    this.signInInfo = changedItem;
  }

  onSubmit(event) {
    event.preventDefault();

    if(!this.allowToSubmit()) {
      return;
    }
    this.setState({
      submit: true,
      errorData: undefined
    });
    
    LoginUseCase.execute(this.signInInfo)
    .then(() => {
      const { history, navigationState: { projectSlug, from } = {} } = this.props;
      this.props.loadUser(() => {
        if(from) {
          history.replace(from);
        }
        else if(projectSlug) {
          history.replace({
            pathname: Routes.project(projectSlug),
            state: { openModal: true }
          });
        }
        else {
          history.replace(Routes.profile());
        }
      });
    })
    .catch((result) => {
      const { errorData } = result;
      this.setState({
        submit: false,
        errorData: errorData
      });
      this.props.showServerErrorIfNeed(result);
    })
  }

  onComeBack() {
    const { history } = this.props;
    if(history.length > 2) {
      history.goBack()
    }
    else {
      history.replace(Routes.index())
    }
  }

  render() {
    return <BaseSessionPage >
      <SignInNav />
      <form onSubmit = { this.onSubmit } >
        { this.form() }
      </form>
    </BaseSessionPage>
  }

  form() {
    const { classes, navigationState } = this.props;

    const { submit, errorData } = this.state;

    const { signInInfo } = this;

    return <React.Fragment>
      <FormFields formFields = { this.formFields } 
                  item = { signInInfo }
                  errorData = { errorData }
                  onItemChange = { this.onItemChange }
                  defaultWeight = { 12 } />
     
      <div className = { classes.signInContainer } >
        <Link to = { {
          pathname: Routes.forgotPassword(),
          state: navigationState
        } }
              className = { classes.forgotPasswordLink } >
          { I18n.t("web.page.sign_in.forgot_password")}
        </Link>
      </div>
      <Button className = { classes.button }
              type = { "submit" }
              disabled = { submit } >
        { I18n.t("shared.sign_in") }
      </Button>
      <div className = { classes.backContainer }>
        <BackButton />
      </div>
    </React.Fragment>
  }

  allowToSubmit() {
    return true;
  }
}

export default compose(withKeepNavigationState, withShowToast, withCurrentUser, withStyles(styles))(SignInPage)
